import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import React from 'react';

const useStyles = makeStyles({
  button: {
    borderRadius: 0,
    marginTop: '2rem',
  },
});
interface Props {
  children: string;
  disabled: boolean;
}

const LoginButton: React.FC<Props> = ({ children, disabled }) => {
  const classes = useStyles();
  return (
    <Button
      fullWidth
      className={classes.button}
      type="submit"
      variant="contained"
      color="primary"
      disabled={disabled}
      endIcon={<ArrowForwardIcon />}
    >
      {children}
    </Button>
  );
};

export default LoginButton;
